<template>
    <div :class="fieldClass">
        <select :class="{ filled: currVal != '' && !isDisabled, error: !isValid }"
        :name="field"
        :id="field"
        :disabled="isDisabled"
        @click="updateCurrValue($event)">
            <option v-for="(item, i) in fieldOptions" :key="i" :value="item.objectId"> {{ item.designation }} </option>
        </select>
        <label :for="field"> {{ labelText }} </label>
        <p v-show="!isValid" class="rgErrorMessage"> {{ errorText }} </p>
    </div>
</template>
<script>
    export default {
        name: 'DropDown',
        props:{
            fieldClass: {type:String, default: 'defaultSelect'},
            field: {type:String},
            fieldOptions: {type: Array, default: () => { return []; }},
            labelText: {type:String},
            isDisabled: {type: Boolean, default: false},
            isValid: { type: Boolean, default: true},
            errorText: {type: String},
        },
        data(){return{
            currVal: '',
        }},
        methods:{
            updateCurrValue(e){
                this.currVal = (!this.isDisabled) ? e.target.value : ''
                this.$emit('update:currOpt', e.target.value)
            }
        }
    }
</script>
<style lang="scss">
    @import './DropDown.scss';
</style>
